import styled from 'styled-components'
import { GriddedContentBlock } from './Utility.styles'
import { DEVICE } from '../../util/constants'
import { Link } from 'gatsby'

export const FooterUpperRegion = styled.div`
  background-color: var(--highlight-blue);
  height: max-content;
`

export const FooterLowerRegion = styled.div`
  background-color: white;
  height: max-content;
`

export const FooterContentRegionGrid = styled(GriddedContentBlock)`
  padding: 48px 0 42px;
  margin: 0;

  @media ${DEVICE.tabletG} {
    padding-top: 58px;
  }
`

export const LogoRow = styled.div`
  grid-column: 2 / 12;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media ${DEVICE.tabletG} {
    flex-direction: row;
  }
`

export const LogoLink = styled.a`
  display: block;
`

export const LogoImage = styled.img`
  margin: 0 0 30px;

  @media ${DEVICE.tabletG} {
    margin: 0 40px;
  }
`

export const Disclaimer = styled.div`
  grid-column: 2 / 12;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.35;
  align-items: center;
  color: var(--highlight-blue);
  margin: 32px 0;
`

export const NavColumn = styled.div`
  grid-column: 2 / 12;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${DEVICE.tabletG} {
    align-items: flex-start;
    grid-column: 2 / 6;
  }

  @media ${DEVICE.laptopL} {
    grid-column: 2 / 5;
  }
`

export const NavList = styled.ul`
  padding-top: 19px;
  font-size: 1.8rem;
  line-height: 1.4;
  color: white;
  text-align: center;

  @media ${DEVICE.tabletG} {
    text-align: left;
  }
`

export const NavItem = styled(Link)`
  text-decoration-line: none;
  color: white;

  li {
    margin-bottom: 10px;
  }

  :hover {
    text-decoration-line: underline;
    color: var(--graphic-accent-purple-1);
  }
`

export const FormColumn = styled.form`
  grid-column: 2 / 12;
  color: var(--content-background-light);
  text-align: center;

  h3 {
    font-size: 2.8rem;
    line-height: 1.36;
  }

  h4 {
    padding-top: 8px;
    font-size: 2rem;
    line-height: 1.6;
    padding-bottom: 36px;
  }

  @media ${DEVICE.tabletG} {
    text-align: left;
    grid-column: 7 / 12;
  }

  @media ${DEVICE.laptopS} {
    grid-column: 6 / 12;
  }

  @media ${DEVICE.laptopL} {
    grid-column: 5 / 12;
  }
`

export const FieldPair = styled.div`
  display: flex;
  flex-direction: column;

  @media ${DEVICE.laptopL} {
    flex-direction: row;
    justify-content: space-between;
  }
`

export const InputText = styled.input`
  color: white;
  font-size: 2rem;
  line-height: 1.6;
  border: none;
  border-bottom: 2px solid var(--content-background-dark-blue);
  background: none;
  outline: none;
  width: 100%;
  margin-bottom: 41px;
  padding-left: 0;

  ::placeholder {
    color: white;
  }
`

export const InputFirstName = styled(InputText)`
  @media ${DEVICE.laptopL} {
    width: 53%;
  }
`
export const InputLastName = styled(InputText)`
  @media ${DEVICE.laptopL} {
    /* margin-left: 10%; */
    width: 43%;
  }
`
export const InputZip = styled(InputText)`
  @media ${DEVICE.laptopL} {
    width: 23%;
  }
`
export const InputEmail = styled(InputText)`
  @media ${DEVICE.laptopL} {
    width: 73%;
  }
`

export const SubmitRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media ${DEVICE.laptopS} {
    flex-direction: row;
    justify-content: flex-end;
  }
`

export const SignUpButtonContainer = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  pointer-events: none;
  padding: 14px 0;
  text-decoration-line: none;
  background-color: var(--highlight-blue);

  svg {
    fill: white;
  }

  svg .rollover {
    display: none;
  }

  :hover {
    svg .rollover {
      display: inherit;
    }

    svg .normal {
      display: none;
    }
  }

  @media ${DEVICE.laptopS} {
    padding-left: 23px;
  }
`

export const SignUpButtonText = styled.p`
  pointer-events: auto;
  font-size: 1.4rem;
  line-height: 1;
  font-weight: bold;
  letter-spacing: 0.02em;
  color: white;
  user-select: none;
  padding: 15px 14px 15px 0;
`
